import React, { useContext, useEffect, useState } from "react";
import Header from "../Header/Header";
import ThreadSidebarWrapper from "../../Prompt/ThreadSidebar/ThreadSidebarWrapper";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../footer/footer";
import { SidebarContext } from "../../../contexts/SidebarContext";
import { getUserAvatar } from "../../../api/userApiFunctions";
import { getUserID } from "../../../Utility/service";
import { ProfileContext } from "../../../contexts/ProfileContext";
import SidebarTour from "../../../Utility/walkthrough/sidebarSteps";


const MainContent = () => {
  const userId = getUserID();
  const { setUserAvatar } = useContext(ProfileContext);
  const { showMenu, setShowMenu } = useContext(SidebarContext);
  const location = useLocation();

  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    const embeddedParam = new URLSearchParams(window.location.search).get("embedded") === "true";
    setIsEmbedded(embeddedParam);
  }, []);

  const [bgColor, setBgColor] = useState("#ffffff");
  const [fontSize, setFontSize] = useState("16px");
  const [textColor, setTextColor] = useState("#000000");
  const [themeColor, setThemeColor] = useState("#F9FAFB");

  useEffect(() => {

    const queryParams = new URLSearchParams(location.search);
    let colorFromUrl = queryParams.get("color");
    let textColorFromUrl = queryParams.get("textColor");
    let themeColorFromUrl = queryParams.get("themeColor");

    if (colorFromUrl) {
      colorFromUrl = colorFromUrl === "red" ? "#ff0000" : colorFromUrl;
      setBgColor(colorFromUrl);
    }

    if (textColorFromUrl) {
      setTextColor(textColorFromUrl);
    }

    if (themeColorFromUrl) {
      setThemeColor(themeColorFromUrl);
    }
  }, [location]);

  useEffect(() => {
    if (
      // location?.pathname === "/public-assistant" ||
      location.pathname === "/chat" ||
      location.pathname.startsWith("/chat/") ||
      location.pathname.startsWith("/agents/")
    ) {
      return
    } else {
      setShowMenu(false);
    }
  }, [location, setShowMenu]);

  const handleFetchUserAvatar = async () => {
    try {
      const { success, data, error } = await getUserAvatar(userId);
      if (!userId) {
        return null;
      }
      if (success) {
        setUserAvatar(data);
      }
    } catch (error) {
      console.error("Error fetching user avatar data:", error);
    }
  };

  useEffect(() => {
    handleFetchUserAvatar();
  }, [userId]);


  return (
    <>
    <SidebarTour/>
      <div
        className="w-100 main-wrapper min-vh-100 d-flex flex-column justify-content-between flex-grow-1"
        style={
          isEmbedded
            ? { backgroundColor: bgColor }
            : {}
        }
      >
        <Header />
        <section className="flex-grow-1 d-flex z-0">
          {/* Sidebar for chat thread */}
          {!isEmbedded &&
            <div className={`thread-sidebar ${showMenu ? "open-sidebar" : ""}`}>
              <ThreadSidebarWrapper />
            </div>
          }
          <div
            className={`main-chat-area-section flex-grow-1 ${showMenu ? "move-main-layout" : ""
              }`}
              style={isEmbedded ? { marginTop: "55px" } : {}}
          >
            <Outlet />
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default MainContent;
